import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	width: 100%;
	height: 100%;
`;

const StyledHead = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 0 20px 20px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);

	img {
		user-select: none;
	}
`;

const StyledNewMessageButton = styled.img`
	width: 20px;
	height: 20px;
	opacity: 0.25;
	transition: opacity 0.3s ease;
	cursor: pointer;

	&:hover {
		opacity: 1;
	}
`;

const StyledDialogsListContainer = styled.div`
	height: 434px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledNoDialogsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding-top: 235px;

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
		text-align: center;
	}
`;

export {
	StyledContainer,
	StyledDialogsListContainer,
	StyledHead,
	StyledNewMessageButton,
	StyledNoDialogsContainer,
};
